export var MeetingType;
(function (MeetingType) {
    MeetingType["ONBOARDING"] = "onboarding";
    MeetingType["REGULAR_CHECKIN"] = "regular_checkin";
    MeetingType["PROJECT_REVIEW"] = "project_review";
    MeetingType["CAREER_GUIDANCE"] = "career_guidance";
    MeetingType["SKILL_ASSESSMENT"] = "skill_assessment";
    MeetingType["GOAL_SETTING"] = "goal_setting";
    MeetingType["FEEDBACK_SESSION"] = "feedback_session";
    MeetingType["OTHER"] = "other";
})(MeetingType || (MeetingType = {}));
export var MeetingStatus;
(function (MeetingStatus) {
    MeetingStatus["SCHEDULED"] = "scheduled";
    MeetingStatus["IN_PROGRESS"] = "in_progress";
    MeetingStatus["COMPLETED"] = "completed";
    MeetingStatus["CANCELLED"] = "cancelled";
    MeetingStatus["RESCHEDULED"] = "rescheduled";
})(MeetingStatus || (MeetingStatus = {}));
export var MeetingPlatform;
(function (MeetingPlatform) {
    MeetingPlatform["ZOOM"] = "zoom";
    MeetingPlatform["GOOGLE_MEET"] = "google_meet";
    MeetingPlatform["MICROSOFT_TEAMS"] = "microsoft_teams";
    MeetingPlatform["SKYPE"] = "skype";
    MeetingPlatform["IN_PERSON"] = "in_person";
    MeetingPlatform["PHONE"] = "phone";
    MeetingPlatform["OTHER"] = "other";
})(MeetingPlatform || (MeetingPlatform = {}));
//# sourceMappingURL=meeting.enum.js.map